var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73886 5.1188C1.05491 5.33268 0.508739 5.81001 0.213186 6.45207L0.033369 6.8428L0.0167239 17.9006L0 28.9585L0.163406 28.6496C0.253276 28.4798 1.44276 26.0005 2.80666 23.1403C5.94107 16.5669 5.86988 16.7065 6.315 16.2613C6.79772 15.7786 7.557 15.4181 8.29221 15.3227C8.63184 15.2786 13.9033 15.2475 21.2738 15.2461L33.6835 15.2436L33.6601 13.3486C33.6378 11.5395 33.6284 11.4376 33.4543 11.1018C33.1976 10.6069 32.705 10.1261 32.2378 9.91462L31.8393 9.73425L24.22 9.71175L16.6006 9.68924L16.1749 9.08657C13.7311 5.62628 13.4854 5.35355 12.6052 5.12427C11.9819 4.96195 2.25619 4.95711 1.73886 5.1188ZM9.62798 17.593C8.69342 17.7146 7.69305 18.3734 7.23394 19.1695C7.12828 19.3528 5.47078 22.7989 3.55062 26.8276C0.216624 33.8228 0.0632212 34.1641 0.14426 34.4079C0.312589 34.9145 0.787725 35.4279 1.35695 35.7182L1.89312 35.9917H16.714H31.5349L32.1303 35.6974C33.1817 35.1778 33.081 35.3447 36.6443 28.2155C38.6664 24.1697 39.861 21.6936 39.9172 21.4315C40.0452 20.8348 40.0268 20.4079 39.8482 19.8297C39.4819 18.6437 38.4382 17.7777 37.1509 17.5917C36.4917 17.4965 10.3607 17.4977 9.62798 17.593Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.36f2514b316b0b8f6d701da4e77c61dc.svg";
export { ForwardRef as ReactComponent };